var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "select-richtext", class: _vm.classes },
    [
      _c("span", { staticClass: "typographies-paragraph-small-semibold" }, [
        _vm._v(_vm._s(_vm.label))
      ]),
      _vm._v(" "),
      _c("CompassIcon", {
        attrs: {
          size: "extra-small",
          icon: "caret-down",
          disabled: _vm.disabled
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }